import React from "react";
import { Notice } from "@justworkshr/milo-core";
import { getNeonRedirectUrl } from "utils/helper";
import styles from "./CensusNotice.module.css";

interface CensusNoticeProps {
  className?: string;
}

const CensusNotice: React.FC<CensusNoticeProps> = ({ className }) => {
  return (
    <div className={className || styles.notice}>
      <Notice title="Missing someone?" color="neutral">
        <>
          Go back to{" "}
          <a
            href={`${getNeonRedirectUrl(
              "/enrollment-hub/applications/core-app/members-form"
            )}`}
          >
            company and team info
          </a>{" "}
          where you can update your team.
        </>
      </Notice>
    </div>
  );
};

export default CensusNotice;
